import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_ADMIN_PASSWORD_CONFIG,
  API_UPDATE_ADMIN_PASSWORD_CONFIG,
} from "../../Apis/ApiEndPoints";
import { IPasswordConfigData } from "./passwordConfigurationType";

export const adminGetPasswordConfig = createAsyncThunk(
  "config/adminGetPasswordConfig",
  async (_, { dispatch }) => {
    const response = await CustomAction(
      Api.get(API_GET_ADMIN_PASSWORD_CONFIG),
      dispatch,
      "config/adminGetPasswordConfig"
    );
    return response;
  }
);

export const adminUpdatePasswordConfig = createAsyncThunk(
  "config/adminUpdatePasswordConfig",
  async (requestBody: IPasswordConfigData, { dispatch }) => {
    const response = await CustomAction(
      Api.put(API_UPDATE_ADMIN_PASSWORD_CONFIG, requestBody),
      dispatch,
      "config/adminUpdatePasswordConfig"
    );

    return response;
  }
);
